import { Modal, Button, Form } from "react-bootstrap";
import { usePAChecklist } from "../pa_checklist_context";
import styles from '../pa_checklist.module.scss'
import { useEffect, useState } from "react";
import SelectInput from '../../../Misc/SelectInput/SelectInput';
import MaterialIconsReact from "material-icons-react";
import MedidasForm from './pa_checklist_medidas_comp';

const PAChecklistMedidas = () => {
  const {
    modalMedidas,
    setModalMedidas,
    referenciaSelecionada,
    listaRomaneioMedidas,
    abrirModalInformacoes,
    medidasAtelier,
    listaPartesMedidas,
    formulariosMedida,
    setFormulariosMedida,
    resultadoCaixa,
    atelierDesenhoTecnico,
    possuiPecaPiloto,

    qtdePecasComposicao, setQtdePecasComposicao,
    formulariosPecasComposicaoUm, setFormulariosPecasComposicaoUm,
    formulariosPecasComposicaoDois, setFormulariosPecasComposicaoDois,
    formulariosPecasComposicaoTres, setFormulariosPecasComposicaoTres
  } = usePAChecklist();

  const [showDesenhoTecnico, setShowDesenhoTecnico] = useState(false);
  const [grupoSelecionado, setGrupoSelecionado] = useState({ label: 'TODAS', value: 1 });
  const [tamanhoSelecionado, setTamanhoSelecionado] = useState(listaRomaneioMedidas[0]);

  useEffect(() => {
    if (medidasAtelier.length > 0) return setGrupoSelecionado({ label: 'DESENVOLVIMENTO INTERNO', value: 5 });
    setGrupoSelecionado({ label: 'TODAS', value: 1 });
  }, []);

  const checkIfOptionIsDisabled = (opt) => {
    if (!referenciaSelecionada.desenvolvimento_interno && opt.value === 5) return true;
    if (referenciaSelecionada.desenvolvimento_interno && opt.value !== 5) return true;
    if (referenciaSelecionada.marca !== 'FOXTON' && [3, 4].includes(opt.value)) return true;
    return false;
  }

  const handleToggleSwitch = (index, formularios, setFormularios) => {
    const medida = formularios[index]?.medida;
    const grades = listaRomaneioMedidas.map(item => item.id_grade_tamanho);

    const updatedFormularios = [...formularios];
    for (const item of updatedFormularios) {
      if (item.medida === medida && grades.includes(item.id_grade)) {
        item.switch = !item.switch;
      }
    }
    setFormularios(updatedFormularios);
  }

  const handleAtualizarPiloto = (index, value, formularios, setFormularios) => {
    const digitsOnly = value.replace(/\D/g, '');
    const paddedValue = digitsOnly.padStart(3, '0');
    const valorFormatado = `${paddedValue.slice(0, -2)}.${paddedValue.slice(-2)}`.replace(/^0+(?=\d\.)/, '');

    const medidaAlvo = formularios[index].medida;

    const atualizados = formularios.map((item, i) =>
      item.medida === medidaAlvo ? { ...item, piloto: valorFormatado } : item
    );

    setFormularios(atualizados);
  }

  const handleQtdePecasComposicaoChange = (value) => {
    const qtde = Math.max(0, Math.min(3, parseInt(value) || 0));
    setQtdePecasComposicao(qtde);
  }

  return (
    <Modal
      show={modalMedidas}
      backdrop={'static'}
      keyboard={false}
      size={'lg'}
      centered={true}
      backdropClassName={styles.backdrop_z_override}
      fullscreen={'lg-down'}
      onHide={() => setModalMedidas(false)}
    >
      <Modal.Header style={{ fontWeight: '500' }} closeButton>
        Checklist {referenciaSelecionada.nf_segunda_qualidade ? '(Segunda Qualidade) ' : ''} | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto} | Descrição: {referenciaSelecionada.descricao_produto} | Desenvolvimento {referenciaSelecionada.desenvolvimento_interno ? 'Interno' : 'Externo'} | {resultadoCaixa.possui_peca_piloto ? 'Possui Peça Piloto' : 'Sem Peça Piloto'}
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <div className={styles.medida_input_wrapper}>
          <SelectInput
            label={'Grupo Partes'}
            value={grupoSelecionado}
            onChange={e => setGrupoSelecionado(e)}
            options={listaPartesMedidas}
            isOptionDisabled={checkIfOptionIsDisabled}
            isClearable={false}
          />

          <SelectInput
            label={'Tamanho'}
            value={tamanhoSelecionado}
            onChange={e => setTamanhoSelecionado(e)}
            options={listaRomaneioMedidas}
            isClearable={false}
          />

          <Form.Group style={{ minWidth: '150px' }}>
            <Form.Label className={styles.form_label} style={{ color: '#000000AE' }}>
              Qtde. peças de combinação (0-3)
            </Form.Label>
            <Form.Control
              type="number"
              min="0"
              max="3"
              value={qtdePecasComposicao}
              onChange={e => handleQtdePecasComposicaoChange(e.target.value)}
              disabled={!referenciaSelecionada}
              style={{ height: '38px', borderColor: '#ccccccff' }}
            />
          </Form.Group>
        </div>

        <div className={styles.separator} />

        {atelierDesenhoTecnico && referenciaSelecionada.desenvolvimento_interno &&
          <div style={{ display: 'flex' }}>
            <div style={{ width: '38px' }} />
            <img src={atelierDesenhoTecnico} width={'50%'} style={{ margin: 'auto' }} />
            <div
              style={{ display: 'flex' }}
              className={styles.eye_btn}
              onClick={() => setShowDesenhoTecnico(true)}
            >
              <MaterialIconsReact
                icon={'visibility'}
                size={20}
                color={'#FFFFFF'}
              />
            </div>
          </div>
        }

        {!atelierDesenhoTecnico && referenciaSelecionada.desenvolvimento_interno &&
          <div className={styles.warn_text}>Não há desenho técnico disponível para esse produto</div>
        }

        <MedidasForm
          formularios={formulariosMedida}
          setFormularios={setFormulariosMedida}
          grupoSelecionado={grupoSelecionado}
          tamanhoSelecionado={tamanhoSelecionado}
          possuiPecaPiloto={possuiPecaPiloto}
          referenciaSelecionada={referenciaSelecionada}
          onToggleSwitch={handleToggleSwitch}
          onAtualizarPiloto={handleAtualizarPiloto}
          titulo="Peça Principal"
        />

        {qtdePecasComposicao > 0 &&
          <MedidasForm
            formularios={formulariosPecasComposicaoUm}
            setFormularios={setFormulariosPecasComposicaoUm}
            grupoSelecionado={grupoSelecionado}
            tamanhoSelecionado={tamanhoSelecionado}
            possuiPecaPiloto={possuiPecaPiloto}
            referenciaSelecionada={referenciaSelecionada}
            onToggleSwitch={handleToggleSwitch}
            onAtualizarPiloto={handleAtualizarPiloto}
            titulo={`Peça de Combinação #1`}
          />
        }

         {qtdePecasComposicao > 1 &&
          <MedidasForm
            formularios={formulariosPecasComposicaoDois}
            setFormularios={setFormulariosPecasComposicaoDois}
            grupoSelecionado={grupoSelecionado}
            tamanhoSelecionado={tamanhoSelecionado}
            possuiPecaPiloto={possuiPecaPiloto}
            referenciaSelecionada={referenciaSelecionada}
            onToggleSwitch={handleToggleSwitch}
            onAtualizarPiloto={handleAtualizarPiloto}
            titulo={`Peça de Combinação #2`}
          />
        }

         {qtdePecasComposicao > 2 &&
          <MedidasForm
            formularios={formulariosPecasComposicaoTres}
            setFormularios={setFormulariosPecasComposicaoTres}
            grupoSelecionado={grupoSelecionado}
            tamanhoSelecionado={tamanhoSelecionado}
            possuiPecaPiloto={possuiPecaPiloto}
            referenciaSelecionada={referenciaSelecionada}
            onToggleSwitch={handleToggleSwitch}
            onAtualizarPiloto={handleAtualizarPiloto}
            titulo={`Peça de Combinação #3`}
          />
        }
      </Modal.Body>
      <Modal.Footer className={styles.modal_footer}>
        <Button
          variant={'secondary'}
          className={styles.footer_btn_processamento}
          onClick={() => setModalMedidas(false)}
        >
          Voltar
        </Button>

        <Button
          variant={'primary'}
          className={styles.footer_btn_processamento}
          onClick={() => abrirModalInformacoes(referenciaSelecionada)}
        >
          Informações
        </Button>
      </Modal.Footer>

      {/* Modal desenho técnico (código mantido igual) */}
      <Modal
        show={showDesenhoTecnico}
        keyboard={false}
        size={'lg'}
        centered={true}
        backdropClassName={styles.backdrop_z_override}
        fullscreen={'lg-down'}
        onHide={() => setShowDesenhoTecnico(false)}
      >
        <Modal.Header closeButton style={{ fontWeight: '500' }}>Desenho Técnico com Cotas</Modal.Header>
        <Modal.Body>
          <img src={atelierDesenhoTecnico} width={'100%'} />
        </Modal.Body>
      </Modal>
    </Modal>
  );
}

export default PAChecklistMedidas;